// Tela de loading exibida durante lazy loading dos portais

export const LoadingScreen: React.FC = () => (
  <div className="flex h-full min-h-screen items-center justify-center bg-navy-dark">
    <div className="flex flex-col items-center gap-4">
      {/* Logo RUTATEC animada */}
      <div className="font-display text-4xl font-bold tracking-wider">
        <span className="text-white">RUTA</span>
        <span className="text-red">TEC</span>
      </div>
      {/* Spinner */}
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-white/20 border-t-white" />
      <p className="font-body text-sm text-white/60">Cargando...</p>
    </div>
  </div>
)
